import {
  GET_INSPECTION_TECHNICAL_CONDITION_BASE,
  GET_INSPECTION_TECHNICAL_CONDITION_BASES,
  GET_INSPECTION_TECHNICAL_CONDITION_BASES_ALL,
  RESET_EXAMINATION_RESULT_FILE,
  SET_EXAMINATION_RESULT_FILE,
  SET_INSPECTION_TECHNICAL_CONDITION_BASES,
} from "../types";

const initialState = {
  data: [],
  paginationData: [],
  selectedObject: {},
  file: null,
  searchParams: {
    ownerLeName: "",
    location: "",
    results: 0,
    startDate: "",
    endDate: "",
    section: null,
    checkStatus: 0,
  },
};

export const inspectionTechnicalConditionBasesReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_INSPECTION_TECHNICAL_CONDITION_BASES:
      return (() => ({
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      }))();
    case GET_INSPECTION_TECHNICAL_CONDITION_BASES:
      return (() => ({
        ...state,
        paginationData: action.data,
      }))();
    case GET_INSPECTION_TECHNICAL_CONDITION_BASES_ALL:
      return (() => ({
        ...state,
        data: [...action.data],
      }))();
    case GET_INSPECTION_TECHNICAL_CONDITION_BASE:
      return (() => ({
        ...state,
        selectedObject: { ...action.selectedObject },
      }))();
    case SET_EXAMINATION_RESULT_FILE:
      return (() => ({
        ...state,
        file: action.data,
      }))();
    case RESET_EXAMINATION_RESULT_FILE:
      return (() => ({
        ...state,
        file: null,
      }))();
    default:
      return state;
  }
};
